<div class="flex width-100 align-items-center gap-3">
  <i class="fs-xlarge pi pi-exclamation-triangle p-confirm-dialog-icon"></i>
  <p>{{data.confirmMessage}}</p>
</div>
